var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ctD-wrap"},[_c('canvas',{ref:"ctD",staticClass:"ctD",style:(_vm.styles),attrs:{"width":"200","height":"200"}},[_vm._v("浏览器不支持Canvas,请升级或改用其它浏览器！")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f1a40fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vue-canvas-countdown@1.0.0@vue-canvas-countdown/src/components/countDown.vue
// module id = null
// module chunks = 